<template>
  <div class="pox-modal" v-if="visibleRatingModal">
    <div :class="isMobile ? 'modal-content-mobile' : 'modal-content-desktop'">
      <div class="close" @click="closeModal">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.41541 8.00017L15.7075 1.7081C16.0984 1.31752 16.0984 0.683775 15.7075 0.293189C15.3166 -0.0977298 14.6835 -0.0977298 14.2926 0.293189L8.0005 6.58525L1.7081 0.293189C1.31718 -0.0977298 0.684109 -0.0977298 0.293189 0.293189C-0.0977298 0.683775 -0.0977298 1.31752 0.293189 1.7081L6.58559 8.00017L0.293189 14.2922C-0.0977298 14.6828 -0.0977298 15.3166 0.293189 15.7071C0.488649 15.9023 0.744814 16 1.00065 16C1.25648 16 1.51264 15.9023 1.7081 15.7068L8.0005 9.41475L14.2926 15.7068C14.488 15.9023 14.7442 16 15 16C15.2559 16 15.512 15.9023 15.7075 15.7068C16.0984 15.3162 16.0984 14.6825 15.7075 14.2919L9.41541 8.00017Z"
            fill="#7A8189"
          />
        </svg>
      </div>
      <div>
        <img :src="img" alt="pox_info" width="500"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    img: {
      type: String,
    },
  },
  computed: {
    isMobile() {
      return screen.width < 756;
    },
    isPartnerTypeFood() {
      return (
        this.order &&
        this.order.partner_type === this.$constants.PARTNER_TYPE.FOOD
      );
    },
  },
  data() {
    return {
      visibleRatingModal: false,
    };
  },
  methods: {
    closeModal() {
      this.visibleRatingModal = false;
    },
    closeRatingDriver() {
      if (this.isPartnerTypeFood) {
        this.ratingForDriver = false;
      } else {
        this.closeModal();
      }
    },
  },
  mounted() {
    // console.log("initRate", this.initRate)
    // console.log("selectedOption", this.selectedOption)
  },
};
</script>
<style lang="scss" scoped>
.pox-modal {
  position: fixed; /* Stay in place */
  z-index: 10; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  .modal-content-desktop {
    background-color: #fefefe;
    // margin: 8% auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    border: 1px solid #888;
    border-radius: 4px;
    width: 480px;

    .close {
      cursor: pointer;
      text-align: right;
      margin-bottom: 10px;
    }
  }
  .modal-content-mobile {
    background-color: #fefefe;
    position: absolute;
    margin: 0;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0%);
    padding: 20px;
    border: none;
    border-radius: 4px;
    width: 100%;

    .close {
      cursor: pointer;
      text-align: right;
      margin-bottom: 10px;
    }
  }
}
</style>
